import React from 'react';

import {
  Input,
  InputContainer,
  InputHeader,
  MenuDesignSectionLabel,
  RemainingCount,
} from './inputs-with-max-length.styles';

type InputWithMaxLengthProps = {
  value: string;
  maxLength: number;
  label: string;
  placeholderText: string;
  width: number;
  margin?: number;
  id?: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

export function InputWithMaxLength({
  value,
  maxLength,
  label,
  placeholderText,
  width,
  margin = 26,
  onChange,
  id = 'input_with_max_length',
}: InputWithMaxLengthProps): JSX.Element {
  function setValue(e: React.ChangeEvent<HTMLInputElement>): void {
    onChange(e);
  }

  return (
    <InputContainer width={width} margin={margin}>
      <InputHeader>
        {label && <MenuDesignSectionLabel htmlFor={id}>{label}</MenuDesignSectionLabel>}
        <RemainingCount>
          {value.length}/{maxLength}
        </RemainingCount>
      </InputHeader>
      <Input
        value={value}
        maxLength={maxLength}
        placeholder={placeholderText}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => setValue(e)}
        width={width}
        id={id}
      />
    </InputContainer>
  );
}
